import { useEffect } from 'react';
import { useIsFetching } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';
import { UpdatedLegalNoticeModal } from 'src/components/LegalUpdateModal';
import { ConsentApiList } from 'src/stores/auth/apis';
import { userDataAtom } from 'src/stores/auth/atoms';
import { ModalType } from 'src/types/Modal';
import { OrderedModalHookType } from './types';
import withLoginUserModalPromise from './withLoginUserModalPromise';
const useUpdatedLegalNoticeModal: OrderedModalHookType = modalPropsPromise => {
  const userData = useAtomValue(userDataAtom);
  const isFetchingUpdates = useIsFetching({
    queryKey: [ConsentApiList.GetConsentRevision]
  });
  useEffect(() => {
    if (!userData) return;
    if (isFetchingUpdates) return;
    if (userData.legalNoticeRevisionPopups === undefined) {
      modalPropsPromise?.resolve(null);
    } else {
      modalPropsPromise?.resolve(userData.legalNoticeRevisionPopups.map(popup => ({
        modalProps: {
          key: ModalType.LEGAL_NOTICE_RE_APPROVAL,
          component: () => <UpdatedLegalNoticeModal legalNoticeRevisionPopup={popup} />
        }
      })));
    }
  }, [isFetchingUpdates, modalPropsPromise, userData]);
};
export default withLoginUserModalPromise(useUpdatedLegalNoticeModal);